var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMusicAsset(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.159.987C9.505 1.53 6.928 2.06 6.417 2.162c-.863.176-.928.193-1.05.313l-.136.126v10.125l-.247-.194c-.551-.433-1.174-.644-1.896-.65-.552-.005-.88.075-1.397.32-.61.285-1.18.866-1.444 1.465A3.2 3.2 0 000 14.853c0 .838.34 1.59.975 2.166a2.8 2.8 0 001.074.633 3.098 3.098 0 003.182-.712c.458-.457.705-.907.834-1.517.058-.268.064-.815.064-4.282v-3.98l5.243-1.105c2.883-.605 5.26-1.118 5.29-1.124.035-.017.047.588.047 2.942v2.965l-.211-.182c-.276-.234-.746-.474-1.163-.582a3.386 3.386 0 00-1.585 0 3.068 3.068 0 00-2.114 1.939c-.129.359-.135.421-.14.917 0 .45.017.582.093.833a3.064 3.064 0 002.22 2.07c.481.12 1.227.09 1.685-.063a3.008 3.008 0 001.203-.736c.323-.319.517-.598.681-.992.223-.541.217-.25.217-7.275v-6.5l-.14-.136c-.118-.114-.17-.137-.318-.131-.082-.006-2.33.439-4.978.986z"
  })));
}

export default __webpack_public_path__ + "adecc84ea4afa189666d0a7ebb68a7da.svg";
export { SvgMusicAsset as ReactComponent };